'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TaxonomyNavigator = require('./TaxonomyNavigator');

var _TaxonomyNavigator2 = _interopRequireDefault(_TaxonomyNavigator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TaxonomyNavigator2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/index.js
// module id = 284
// module chunks = 11